import initBackToTop from './components/back-to-top'
import initAjaxCart from './components/ajax-cart'
import initCustomSelects from './components/custom-select'
import initCursorSmoke from './components/cursor-smoke'
import initEventCountdown from './components/event-countdown'
import initEventSingle from './components/event-single'
import initHeroAnimations from './components/hero-animations'
import initLoader from './components/loader'
import initModal from './components/modal'
import initProductSingle from './components/product-single'
import initScrollReveal from './components/scroll-reveal'
import initShareLinks from './components/share-links'
import initShopToolbar from './components/shop-toolbar'
import initSiteHeader from './components/site-header'
import initWishlist from './components/wishlist'
import initWooQuantity from './components/woo-quantity'

const boot = () => {
  initBackToTop()
  initAjaxCart()
  initCustomSelects()
  initSiteHeader()
  initLoader()
  initModal()
  initShopToolbar()
  initProductSingle()
  initShareLinks()
  initScrollReveal()
  initWishlist()
  initWooQuantity()
  initCursorSmoke()
  initHeroAnimations()
  initEventCountdown()
  initEventSingle()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot)
} else {
  boot()
}



// WEBPACK FOOTER //
// ./resources/assets/js/app.js